/* eslint-disable */
const config = {
	initialState: {
		store: {
			id: -999,
			name: '',
		},
		multiStore: {
			id: [],
			name: [],
		},
		filterMultiStore: {
			id: [],
			name: [],
		},
		fromPod: -999,
		toPod: -999,
		vendors: {
			id: [],
			name: [],
		},
		brand: {
			id: null,
			name: '',
		},
		deliverFrom: {
			id: -999,
			name: '',
		},
		shift: {
			id: null,
			name: '',
		},
		processType: {
			id: null,
			name: '',
		},
		fromProcess: {
			id: [],
			name: [],
		},
		toProcess: {
			id: [],
			name: [],
		},
		group: {
			id: null,
			name: '',
		},
		region: {
			id: null,
			name: '',
		},
		productExclusive: {
			id: null,
			name: '',
		},
		raisedBy: null,
		status: [],
		products: {
			id: [],
			name: [],
		},
		product: {
			id: null,
			name: '',
		},
		productWithVariant: {
			productData: [],
			values: [],
			labels: [],
		},
		confidence: 'Lessthan',
		defects: [],
		type: 'Select Type',
		imagesType: null,
		productCategories: {
			id: [],
			name: [],
		},
		productCategory: {
			id: null,
			name: '',
		},
		identificationType: 'AI',
		timeType: {
			value: 'annotation',
			label: 'Annotation',
		},
		featureType: 'QUALITY',
		page: 6,
		dateRange: {
			active: true,
			from: new Date(),
			to: new Date(),
		},
		dateOnly: {
			active: false,
			date: new Date(),
		},
		conf: {
			minConf: 0.5,
			maxConf: 1,
		},
		paymentType: null,
		paymentStatus: null,
		customExclusiveFilters: {},
		productionPlanDuration: 'Week',
		productionPlan: {
			id: [],
			name: [],
		},
		orderType: 'capex',
		exportType: '',
		skuType: '',
		skuTypeMulti: [],
		allProcessType: {
			id: null,
			name: '',
		},
		allProcessTypeMulti: {
			id: [],
			name: [],
		},
		mealType: null,
		mealTypeMulti: [],
		duplicate: null,
		validation: null,
		identified: null,
		feature: null,
		tab: '',
		longtermMultiSelect: {
			id: [],
			name: [],
		},
		longtermSingleSelect: {
			id: null,
			name: '',
		},
		productionPlanStatus: 'ALL',
	},
	deserializer: (
		filters,
		isInternal,
		DEFAULT_FILTERS_VALUE = [],
		filtersInfo = {}
	) => {
		const req = {};
		if (filtersInfo?.productionPlan?.show === true) {
			req.productionPlan = filters?.productionPlan;
		}
		if (filtersInfo?.skuType?.show === true) {
			if (filtersInfo?.skuType?.multiSelect) {
				req.skuTypeMulti = filters?.skuTypeMulti;
			} else {
				req.skuType = filters?.skuType;
			}
		}
		if (filtersInfo?.paymentType?.show === true) {
			req.paymentType = filters?.paymentType;
		}
		if (filtersInfo?.productWithVariants?.show === true) {
			req.productWithVariant = filters?.productWithVariant;
		}
		if (filtersInfo?.paymentStatus?.show === true) {
			req.paymentStatus = filters?.paymentStatus;
		}
		if (filtersInfo?.deliverFrom?.show === true) {
			req.deliverFrom = filters?.deliverFrom;
		}
		if (filtersInfo?.shift?.show === true) {
			req.shift = filters?.shift;
		}
		if (filtersInfo?.type?.show === true) {
			req.type = filters?.type;
		}
		if (filtersInfo?.kitchenBaseStore?.show) {
			req.fromPodFilter = filters?.fromPod;
		}
		if (filtersInfo?.pods?.show) {
			req.toPodFilter = filters?.toPod;
		}
		if (
			filtersInfo?.store?.show ||
			DEFAULT_FILTERS_VALUE?.includes('store') ||
			DEFAULT_FILTERS_VALUE?.includes('filteredStore') ||
			filtersInfo?.filteredStore?.show
		) {
			if (filtersInfo?.store?.multiSelect) {
				req.multiStore = filters?.multiStore;
			} else {
				req.store = filters?.store;
			}
		}
		if (filtersInfo?.filteredStore?.show && filtersInfo?.filteredStore?.multiSelect) {
			req.filterMultiStore = filters?.filterMultiStore;
		}
		if (
			filtersInfo?.group?.show ||
			DEFAULT_FILTERS_VALUE?.includes('group')
		) {
			req.group = filters?.group;
		}
		if (
			filtersInfo?.regions?.show ||
			DEFAULT_FILTERS_VALUE?.includes('regions')
		) {
			req.region = filters?.region;
		}
		if (
			filtersInfo?.productExclusive?.show ||
			DEFAULT_FILTERS_VALUE?.includes('productExclusive')
		) {
			req.productExclusive = filters?.productExclusive;
		}
		if (
			filtersInfo?.brand?.show ||
			DEFAULT_FILTERS_VALUE?.includes('brand')
		) {
			req.brand = filters?.brand;
		}
		if (
			filtersInfo?.raisedBy?.show ||
			DEFAULT_FILTERS_VALUE?.includes('raisedBy')
		) {
			req.raisedBy = filters?.raisedBy;
		}
		if (
			filtersInfo?.status?.show ||
			DEFAULT_FILTERS_VALUE?.includes('status')
		) {
			req.status = filters?.status;
		}
		if (
			(filtersInfo?.vendor?.show ||
				DEFAULT_FILTERS_VALUE?.includes('vendor')) && !filtersInfo?.vendor?.singleSelect
		) {
			req.vendors = filters?.vendors;
		}
		if (
			(filtersInfo?.vendor?.show ||
				DEFAULT_FILTERS_VALUE?.includes('vendor')) && filtersInfo?.vendor?.singleSelect
		) {
			req.vendor = filters?.vendor;
		}
		if (
			filtersInfo?.buyer?.show ||
			DEFAULT_FILTERS_VALUE?.includes('buyer')
		) {
			req.buyer = filters?.vendors;
		}
		if (
			(filtersInfo?.product?.show ||
				DEFAULT_FILTERS_VALUE?.includes('product')) && !filtersInfo?.product?.singleSelect
		) {
			req.products = filters?.products;
		}
		if (
			(filtersInfo?.product?.show ||
				DEFAULT_FILTERS_VALUE?.includes('product')) && filtersInfo?.product?.singleSelect
		) {
			req.product = filters?.product;
		}
		if (
			filtersInfo?.imagesType?.show ||
			DEFAULT_FILTERS_VALUE?.includes('imagesType')
		) {
			req.imagesType = filters?.imagesType;
		}
		if (
			(filtersInfo?.productCategory?.show ||
				DEFAULT_FILTERS_VALUE?.includes('productCategory')) && !filtersInfo?.productCategory?.singleSelect
		) {
			req.productCategories = filters?.productCategories;
		}
		if (
			(filtersInfo?.productCategory?.show ||
				DEFAULT_FILTERS_VALUE?.includes('productCategory')) && filtersInfo?.productCategory?.singleSelect
		) {
			req.productCategory = filters?.productCategory;
		}
		if (
			filtersInfo?.identificationType?.show ||
			DEFAULT_FILTERS_VALUE?.includes('identificationType')
		) {
			req.identification = filters?.identificationType;
		}
		if (
			(isInternal && filtersInfo?.confidence?.show) ||
			DEFAULT_FILTERS_VALUE?.includes('confidence')
		) {
			req.conf = filters?.conf;
		}
		if (
			(isInternal && filtersInfo?.timeType?.show) ||
			DEFAULT_FILTERS_VALUE?.includes('timeType')
		) {
			req.timeType = filters?.timeType;
		}
		if (
			(filtersInfo?.egaPercentage?.show || DEFAULT_FILTERS_VALUE?.includes('egaPercentage')) && filters?.egaPercentage?.checked
		) {
			req.egaPercentage = filters?.egaPercentage?.value;
		}
		if (
			filtersInfo?.pageLimit?.show ||
			DEFAULT_FILTERS_VALUE?.includes('pageLimit')
		) {
			req.page = filters?.pageLimit;
		}
		if (
			filtersInfo?.dateRange?.show ||
			DEFAULT_FILTERS_VALUE?.includes('dateRange')
		) {
			req.dateRange = filters?.dateRange;
		}
		if (
			filtersInfo?.dateRangeWithType?.show ||
			DEFAULT_FILTERS_VALUE?.includes('dateRangeWithType')
		) {
			req.dateRange = filters?.dateRange;
		}
		if (
			filtersInfo?.dateOnly?.show ||
			DEFAULT_FILTERS_VALUE?.includes('dateOnly')
		) {
			req.dateOnly = filters?.dateOnly;
		}
		if (
			filtersInfo?.features?.show ||
			DEFAULT_FILTERS_VALUE?.includes('features')
		) {
			req.labels = filters?.defects;
		}
		if (
			filtersInfo?.featureType?.show ||
			DEFAULT_FILTERS_VALUE?.includes('featureType')
		) {
			req.featureType = filters?.featureType;
		}
		if (
			filtersInfo?.processType?.show ||
			DEFAULT_FILTERS_VALUE?.includes('processTypes')
		) {
			req.processTypes =
				filters?.processTypes?.id !== null
					? {
						id: [filters?.processTypes?.id],
						name: filters?.processTypes?.name,
					} : null;
		}
		if (
			filtersInfo?.fromProcess?.show ||
			DEFAULT_FILTERS_VALUE?.includes('fromProcess')
		) {
			req.fromProcess = filters?.fromProcess;
		}
		if (
			filtersInfo?.toProcess?.show ||
			DEFAULT_FILTERS_VALUE?.includes('toProcess')
		) {
			req.toProcess = filters?.toProcess;
		}
		if (
			filtersInfo?.dateRangeOnly?.show ||
			DEFAULT_FILTERS_VALUE?.includes('dateRangeOnly')
		) {
			req.dateRange = filters?.dateRange;
		}
		if (
			filtersInfo?.customExclusiveFilters?.show ||
			DEFAULT_FILTERS_VALUE?.includes('customExclusiveFilters')
		) {
			req.customExclusiveFilters = filters?.customExclusiveFilters;
		}
		if (
			filtersInfo?.status?.show ||
			DEFAULT_FILTERS_VALUE?.includes('status')
		) {
			if (filters.status === 'ALL') {
				req.status = null;
			} else {
				req.status = filters?.status;
			}
		}
		if (
			filtersInfo?.allProcessType?.show
		) {
			if (filtersInfo?.allProcessType?.multiSelect) {
				req.allProcessTypeMulti = filters?.allProcessTypeMulti;
			} else {
				req.allProcessType = filters?.allProcessType;
			}
		}
		if (
			filtersInfo?.mealType?.show
		) {
			if (filtersInfo?.mealType?.multiSelect) {
				req.mealTypeMulti = filters?.mealTypeMulti;
			} else {
				req.mealType = filters?.mealType;
			}
		}
		if (
			filtersInfo?.duplicate?.show ||
			DEFAULT_FILTERS_VALUE?.includes('duplicate')
		) {
			req.duplicate = filters?.duplicate;
		}
		if (
			filtersInfo?.validation?.show ||
			DEFAULT_FILTERS_VALUE?.includes('validation')
		) {
			req.validation = filters?.validation;
		}
		if (
			filtersInfo?.identified?.show ||
			DEFAULT_FILTERS_VALUE?.includes('identified')
		) {
			req.identified = filters?.identified;
		}
		if (
			filtersInfo?.feature?.show ||
			DEFAULT_FILTERS_VALUE?.includes('feature')
		) {
			req.feature = filters?.feature;
		}
		if (filtersInfo?.tab?.show) {
			req.tab = filters?.tab;
		}
		if (filtersInfo?.longTermPlan?.show) {
			if (filtersInfo?.longTermPlan?.multiSelect) {
				req.longTermPlanMulti = filters?.longtermMultiSelect;
			} else {
				req.longTermPlan = filters?.longtermSingleSelect;
			}
		}
		if (filtersInfo?.ingredient?.show) {

			req.ingredient = filters?.ingredient;
		}
		req.orderType = filters?.orderType;
		req.exportType = filters?.exportType;
		if (filtersInfo?.productionPlanStatus?.show) {
			req.productionPlanStatus = filters?.productionPlanStatus;
		}
		return req;
	},
};

export default config;
